import Node from './Node';
import Step from './Step';

class Path {
    constructor(nodes, getStepFromDecisionTree) {
        this.nodes = nodes;
        this.getStepFromDecisionTree = getStepFromDecisionTree;
    }

    toStep = (node) =>
        new Step({
            id: node.stepId,
            ...this.getStepFromDecisionTree(node.stepId)
        });
    toSteps = () => this.nodes.map(this.toStep);
    isChosen = (stepId, choiceId) =>
        this.nodes?.find((x) => x.stepId === stepId)?.choiceId === choiceId;

    setSelectedChoice = (choice) => {
        this.nodes = this.nodes.map((x) =>
            x.stepId === choice.stepId
                ? new Node({
                    ...x,
                    choiceId: choice.id
                })
                : x
        );
        return this;
    };

    truncateUnselectedSteps = (choice) => {
        let chosenStepIndex = this.nodes.findIndex(
            (x) => x.stepId === choice.stepId
        );
        if (chosenStepIndex === -1) {
            throw new Error(`Couldn't find node: '${choice.id}' in the path`);
        }
        this.nodes = this.nodes.slice(0, chosenStepIndex + 1);
        return this;
    };

    addTargetStep = (choice) => {
        this.nodes = this.nodes.concat(new Node({ stepId: choice.target }));
        return this;
    };
}

export default Path;
